export default {
  state: {
    type: "delete",
    headerText: null,
    bodyComponent: null,
    bodyComponentData: null,
    isShown: false
  },
  mutations: {
    setConfirmationModalType(state, type) {
      state.type = type;
    },
    setConfirmationModalHeaderText(state, text) {
      state.headerText = text;
    },
    setConfirmationModalBodyComponent(state, component) {
      state.bodyComponent = component;
    },
    setConfirmationModalBodyComponentData(state, data) {
      state.bodyComponentData = data;
    },
    setConfirmationModalIsShown(state, bool) {
      state.isShown = bool;
    },
    setConfirmationModalParams(state, params) {
      state.type = params.type;
      state.headerText = params.headerText;
      state.bodyComponent = params.bodyComponent;
      state.bodyComponentData = params.bodyComponentData;
      state.isShown = params.isShown;
    },
    resetConfirmationModalParams(state) {
      state.type = null;
      state.headerText = null;
      state.bodyComponent = null;
      state.bodyComponentData = null;
      state.isShown = false;
    }
  }
};
